export default __webpack_public_path__ + "static/media/travel.c162afc4.png";